import React, { useState, useMemo, useEffect } from 'react'
import { Tabs, Tag, Typography } from 'antd'
import { groupBy, orderBy } from 'lodash'

export interface KeyWotdItemType {
  AppearanceTimestamp: string
  /** 和音频开始时间的差值 */
  diffTime: string
  /** 分组ID */
  groupId: number
  /** 分组名称 */
  groupName: string
  /** 关键词 */
  keyword: string
  /** 距离音频进度条开始节点的距离 */
  left: string
  standardTime: string
}

interface PropsType {
  /** 关键词 */
  list: KeyWotdItemType[]
  /** 关键词类型 客户 / 客服 */
  type: string
  onClick: (item: KeyWotdItemType) => void
}

const KeyWordTab: React.FC<PropsType> = (props) => {
  const { list, type, onClick } = props
  const [activeKey, setActiveKey] = useState<string | undefined>()
  const [tabsItemsOptions, setTabsItemsOptions] = useState([])

  // 关键词按照分组ID进行分组
  const groupList = useMemo(() => {
    // 将关键词数据按照分组ID进行分组
    const groupByGroupByList = groupBy(orderBy(list, ['groupId'], ['asc']), 'groupId')
    const newList = []
    Object.keys(groupByGroupByList).forEach(groupId => {
      newList.push({
        groupId,
        groupName: groupByGroupByList[groupId][0].groupName,
        list: orderBy(groupByGroupByList[groupId], ['AppearanceTimestamp'], ['asc']),
      })
    })
    return newList
  }, [list])

  /** 获取 Tabs items 配置 */
  const getTabsItemsOptions = () => {
    const items = groupList.map(item => {
      const children = (
        <>
          {item.list.map((i, index) => (
            <Tag
              color="default"
              key={index}
              onClick={() => {
                onClick && onClick(i)
              }}>
              {/* @ts-ignore */}
              <Typography.Text ellipsis={{ tooltip: i.keyword }}>{i.keyword}</Typography.Text>
            </Tag>
          ))}
        </>
      )
      return ({
        label: item.groupName,
        key: item.groupId,
        children,
      })
    })
    setTabsItemsOptions(items)
  }

  useEffect(() => {
    setActiveKey(groupList?.[0]?.groupId)
    getTabsItemsOptions()
  }, [groupList])

  return (
    <>
      <div className="key-word-tab">
        <p className="label">{type === 'salesKeywordList' ? '客服' : '客户'}关键词</p>
        <Tabs
          activeKey={activeKey}
          onChange={(v) => setActiveKey(v)}
          items={tabsItemsOptions}
          tabPosition="top"
        />
      </div>
    </>
  )
}

export default KeyWordTab
